module.exports = __webpack_public_path__ + "static/media/ic_badge_black.a2ff5d3c.png";